import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vue-datetime/dist/vue-datetime.css';
import axios from 'axios';



axios.defaults.withCredentials = true;
axios.defaults.headers.get["Cache-Control"] = "no-cache, no-store";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.response.use(
  (resp) => {
    let fe_version = resp.headers['fe-version'] || 'default';
    if (fe_version !== localStorage.getItem('fe-version') && resp.config.method == 'get') {
      localStorage.setItem('fe-version', fe_version);
      window.location.reload(); // For new version, simply reload on any get
    }
    return Promise.resolve(resp);
  },
)
import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(axios);
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');